export function validateVehicleHasProvincePayload(payload) {
  if (!payload?.provinceId) {
    return "La provincia es obligatoria.";
  }

  if (!payload?.vehicleId) {
    return "El vehiculo es obligatorio.";
  }

  if (typeof payload?.active !== "boolean") {
    return "El estado activo es obligatorio.";
  }

  if (
    payload?.fareBase === "" ||
    payload?.fareBase === null ||
    payload?.fareBase === undefined
  ) {
    return "La tarifa base es obligatoria.";
  }

  if (Number(payload.fareBase) < 1) {
    return "La tarifa base debe ser minimo 1.0.";
  }

  return null;
}
